/// <amd-module name="Build/Pipelines/SignalRHub" />
import { BuildSignalRActionCreator } from "Build/Pipelines/Actions/SignalR";
import {
    HubNames,
    IBuildDetailHubServer,
    IBuildDetailHubClient,
    getBuildProxyToRegister
} from "Build/Common/Library/SignalRHubProxies";
import { TimelineRecordUpdate } from "Build/Common/Library/Types";

import {
    SignalRHub,
    IHubHostInformation,
    IHubListener
} from "VSS/Features/SignalR/Hub";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";
import { IVssPageContext } from 'VSS/Platform/Context';

export interface IBuildSignalRHubOptions {
    hostInformation: IHubHostInformation;
    projectId: string;
    actionCreator: BuildSignalRActionCreator;
    listener?: IHubListener;
    pageContext: IVssPageContext;
}

export class BuildSignalRHub extends SignalRHub<IBuildDetailHubClient, IBuildDetailHubServer> {
    private _options: IBuildSignalRHubOptions;

    public static s_userInactivityTimeoutMs = 30 * 60 * 1000; // 30 minutes

    constructor(options: IBuildSignalRHubOptions) {
        super({
            hostInformation: options.hostInformation,
            name: HubNames.buildDetailHub,
            listener: options.listener || new BuildSignalRHubListener(options.actionCreator),
            userInactivityTimeoutMs: BuildSignalRHub.s_userInactivityTimeoutMs,
            pageContext: options.pageContext
        });

        this._options = options;

        this.initializeProxy(getBuildProxyToRegister, this._initializeClient);
    }

    public watchProject() {
        this.start().then(() => {
            const hub = this.hub;
            if (hub) {
                hub.server.watchProject(this._options.projectId);
            }
        });
    }

    public stopWatchingProject() {
        const hub = this.hub;
        if (hub) {
            hub.server.stopWatchingProject(this._options.projectId);
        }
    }

    private _initializeClient = (proxy: ISignalRHubProxy<IBuildDetailHubClient, IBuildDetailHubServer>) => {
        proxy.client.buildUpdated2 = (definitionId: number, buildId: number, definitionScope: string) => {
            this._options.actionCreator.buildUpdated(buildId, definitionId, definitionScope);
        };

        proxy.client.stagesUpdated = (buildId: number, timelineId: string, stageUpdates: TimelineRecordUpdate[]) => {
            this._options.actionCreator.stagesUpdated(buildId, timelineId, stageUpdates);
        }
    }
}

class BuildSignalRHubListener implements IHubListener {
    private _actionCreator: BuildSignalRActionCreator;
    private _isDisconnectivityTriggered: boolean = false;
    private _isUserInactivityTriggered: boolean = false;

    constructor(actionCreator: BuildSignalRActionCreator) {
        this._actionCreator = actionCreator;
    }

    isConnecting(): void {

    }

    isConnected(): void {

    }

    isDisconnected(): void {
        if (!this._isUserInactivityTriggered && !this._isDisconnectivityTriggered) {
            this._isDisconnectivityTriggered = true;
        }
    }

    isReconnected(): void {

    }

    isReconnecting(): void {

    }

    isSlow(): void {

    }

    isUserActive(): void {

    }

    isUserInactive(): void {
        if (!this._isDisconnectivityTriggered) {
            this._isUserInactivityTriggered = true;
            this._actionCreator.isUserInactive();
        }
    }
}